import React, { useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { PLAY_RESOURCE_DETAILS } from '../../../apiClient/apiEndpoints';

const PlayResource = () => {
    const params = useParams();
    const iframeRef = useRef(null);
    const configData = useSelector((state) => state.configSlice);
    const userData = useSelector((state) => state.userSlice);
    const {id} = params;
    const [webGlFile, setWebGlFile] = useState(null);

    const getResourcePlayDetails =async()=>{
        try {
            const {data} = await axios.get(`${configData.config.UNO_URL}${PLAY_RESOURCE_DETAILS}/${id}`, {
                headers: {
                  Authorization: `Bearer ${userData.token}`,
                }
              });
              setWebGlFile(data?.embed || "");

        } catch (error) {
            console.log(error);
        }
    }

    useEffect(()=>{
            getResourcePlayDetails()
    },[id])

  return (
    <>
      {webGlFile && 
       <iframe title="play" ref={iframeRef} className="webGlIFrame" src={webGlFile} allowFullScreen />
      }
    </>
  )
}


export default PlayResource;